import { render, staticRenderFns } from "./RsaSchedaInfermieristicaValutazioneAdlEditComponent.vue?vue&type=template&id=2d967b04"
import script from "./RsaSchedaInfermieristicaValutazioneAdlEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaInfermieristicaValutazioneAdlEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports